import React from 'react';
import { useEffect, useRef } from 'react';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootState, AppDispatch } from './store';
import { fetchBranches } from './slices/branchSlice';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const usePrevious = <T extends unknown>(value: T): T | undefined => {
	const ref = useRef<T>();
	useEffect(() => {
		ref.current = value;
	});
	return ref.current;
};
export const useQuery = () => {
	const { search } = useLocation();
	return React.useMemo(() => new URLSearchParams(search), [search]);
};

export const useBranches = () => {
	const dispatch = useAppDispatch();
	const { branches, loading, error } = useAppSelector((state) => state.branch);

	useEffect(() => {
		dispatch(fetchBranches());
	}, [dispatch]);

	return { branches, loading, error };
};
